export enum STORAGE_KEY {
  WALLET_FEATURE = 'wallet-feature',
  MOONERS_NEW = 'mooners-new',
  MOONERS_OLD = 'mooners-old',
  WALLETS_OLD = 'wallets-old'
}